import React from 'react';

import { FormField, Heading, Label } from '@zillow/constellation-10';
import YesAndNo from '../../Widgets/YesAndNo';
import type { Section } from '../../../models';

type Props = {
  utilityName: string;
  deliveredToAreasOtherThanTenantsUnitField: string;
  setSectionValues: (keyValuePairs: object) => void;
  section: Section;
};

export default function DeliveredToAreasOtherThanTenantsUnit({
  utilityName,
  deliveredToAreasOtherThanTenantsUnitField,
  setSectionValues,
  section,
}: Props): JSX.Element {
  function yesDeliveredToAreas(): void {
    setSectionValues({
      [deliveredToAreasOtherThanTenantsUnitField]: true,
    });
  }

  function noDeliveredToAreas(): void {
    setSectionValues({
      [deliveredToAreasOtherThanTenantsUnitField]: false,
    });
  }

  return (
    <>
      <Heading level={3} textStyle="responsive.heading-xs" css={{ marginBottom: 'layout.tight' }}>
        {utilityName}
      </Heading>
      <FormField
        required
        label={
          <Label>Will {utilityName.toLowerCase()} service be delivered to areas other than that tenant’s unit?</Label>
        }
        control={
          <YesAndNo
            yesActive={section.getFieldValue(deliveredToAreasOtherThanTenantsUnitField)}
            yesHandler={yesDeliveredToAreas}
            noHandler={noDeliveredToAreas}
          />
        }
      />
    </>
  );
}
